import React, { memo, useState,useEffect } from "react";
import {useSelector,shallowEqual} from 'react-redux';

import { submitInfo,isLike } from '../../services';
import {ZH_WX_OPENID} from '../../services/constants'
import { isWx } from '../../tools';

import MenuCpn from "@/components/Menu/Menu-cpn";
import FooterCpn from "@/components/Footer/Footer-cpn";
import LoadingCpn from "@/components/Loading/Loading-cpn";
import ResultCpn from "../../components/Result/Result-cpn";
import ResultCodeCpn from "../../components/Result/ResultCode-cpn";
import InputCpn from '@/components/input-types/input-cpn';
import TextAreaCpn from '@/components/input-types/TextArea-cpn';


import { rules } from '@/tools/rules';
import { Form, Button } from 'antd';
import { Wrap } from './style'

export default memo(function Answer() {

  useEffect(() => {
    document.getElementById('root').scrollTop = 0;
    document.title = '我要提问';
  }, []);

// 获取到redux中的数据
const {data} = useSelector(state =>({
  data:state
}),shallowEqual);

// 变量
const [isLoading, setIsLoading] = useState(false);
const [isResult, setIsResult] = useState(false);
const [isResultCode, setIsResultCode] = useState(false);


const onFinish = async(values) => {
  setIsLoading(true)
  const {eventUID,uid,companyID}  = data;
  if (isWx()) {
    // 在微信端
    const openId = localStorage.getItem(ZH_WX_OPENID);
      await submitInfo(values,eventUID,uid,companyID,openId);
      
      if (openId) {
        const result = await isLike(openId,uid,companyID);
        console.log(result);
          // 如果存在这个值说明没有关注公众号
          const { qrUrl} = result.data
          if (qrUrl) {
            setIsResultCode(true);
            setIsLoading(false);
            // 出现公众号二维码
          }else{
            setIsResult(true)
            setIsLoading(false);
            // 感谢您的填写
          }
      }
   
  }else{
    // 非微信端
    try {
      await submitInfo(values,eventUID,uid,companyID);
      setIsResult(true);
      setIsLoading(false);
    } catch (error) {
     return alert('错误请重试！')
    }
  }

};


const [formElements, setFormElements] = useState();
useEffect(() => {
  if (JSON.stringify(data)!=='{}'){
    let formElements = JSON.parse(data.formElements);
    setFormElements(formElements);
  }
  
}, [data])

  

  return (
    <div>
      {isLoading && <LoadingCpn/>}
      {isResult && <ResultCpn/>}
      {isResultCode && <ResultCodeCpn/>}
      

      <MenuCpn/>
      <Wrap>
        <section>
        <Form  name="control-hooks" onFinish={onFinish}>
            {
              formElements && formElements.filter( item =>{
                return item.type === 101
              }).map( (item,index) =>{
                return <InputCpn key={item.title} info={item} rules={rules[index]} ></InputCpn>
              })
            }

            {
              formElements && formElements.filter( item =>{
                return item.type === 102
              }).map( (item,index) =>{
                return <TextAreaCpn key={item.title} info={item} rules={rules[3]}></TextAreaCpn>
              })
            }
            
            <Form.Item className="btn">
              <Button htmlType="submit">提交</Button>
            </Form.Item>
          </Form>
        </section>
        <FooterCpn />
      </Wrap>
    </div>
  );
});
